import axiosClient from "./config";
const apiClient = axiosClient;
export default apiClient;